function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PapuaNewGuineaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1999",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1999)",
    children: [/*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "#E11C1B"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3L24 21H0V3Z",
      fill: "#1D1D1D"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.31256 16.7013H6.31143L6.78646 15.5814L7.34483 16.6938L8.36822 16.7498L7.49362 17.7017L7.94269 18.8485L6.83099 18.2101L5.8044 18.8542L6.19165 17.7407L5.31256 16.7013Z",
      fill: "#EEEEF6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.31256 13.7013H3.31143L3.78646 12.5814L4.34483 13.6938L5.36822 13.7498L4.49362 14.7017L4.94269 15.8485L3.83099 15.2101L2.8044 15.8542L3.19165 14.7407L2.31256 13.7013Z",
      fill: "#EEEEF6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.31256 12.2013H6.31143L6.78646 11.0814L7.34483 12.1938L8.36822 12.2498L7.49362 13.2017L7.94269 14.3485L6.83099 13.7101L5.8044 14.3542L6.19165 13.2407L5.31256 12.2013Z",
      fill: "#EEEEF6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.28345 15.4232L7.97005 15.4003L8.2179 14.6922L8.49616 15.3966L9.12796 15.4573L8.55903 15.8595L9.01788 16.5719L8.2218 16.2741L7.53182 16.5815L7.89619 15.8791L7.28345 15.4232Z",
      fill: "#EEEEF6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.78345 13.9232L9.47005 13.9003L9.7179 13.1922L9.99616 13.8966L10.628 13.9573L10.059 14.3596L10.5179 15.0719L9.7218 14.7741L9.03182 15.0815L9.39619 14.3791L8.78345 13.9232Z",
      fill: "#EEEEF6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.8129 4.5C15.8129 4.5 13.4963 4.96215 14.1465 8.18238H13.816C13.816 8.18238 13.843 8.01435 13.5253 7.91582C13.2075 7.8173 13.2712 7.85428 13.1072 7.91582C12.9432 7.97736 11.9456 7.91582 11.9456 7.91582V8.03909L12.6516 8.34398C12.6516 8.34398 12.6342 8.59785 12.9293 8.73853C13.2244 8.87921 13.4387 8.947 13.4387 8.947C13.4387 8.947 13.4824 9.22714 13.2059 9.22714C12.9293 9.22714 11.817 8.86658 11.4214 9.75242C11.0258 10.6383 10.5 11.2882 10.5 11.2882H11.0932L10.934 11.486H11.6019L11.4214 11.5885C11.4214 11.5885 12.2477 11.5793 12.3121 11.486C12.3766 11.3927 12.3121 11.7389 12.3121 11.7389C12.3121 11.7389 13.1126 11.3734 13.1565 11.2882L13.5301 11.5445L13.6365 11.1108L14.0374 11.2882L14.1465 10.875C14.1465 10.875 15.2806 12.7716 16.1407 12.6627V12.348L16.9256 12.6627L17.0253 12.5228C17.0253 12.5228 17.9735 12.9094 18.2653 12.9452L18.0571 12.5228H18.2653L18.0571 11.7389H18.2653L17.8489 11.1108L17.9656 10.9407L17.8884 10.7172C17.8884 10.7172 19.415 11.2035 19.3462 11.9773C19.2773 12.751 18.5974 13.0632 18.5974 13.0632C18.5974 13.0632 17.9454 13.2629 17.3565 13.22C17.3565 13.22 17.824 13.7722 18.8131 13.5851C19.8022 13.3979 20.13 12.4389 20.13 12.4389C20.13 12.4389 20.5835 13.3809 20.2102 13.8762C19.8368 14.3715 18.1744 14.7193 18.1744 14.7193C18.1744 14.7193 18.7759 15.0719 19.3462 14.9816C19.9164 14.8912 20.8032 14.3949 20.9752 13.5851C21.1471 12.7752 20.382 11.2809 20.0355 11.1108L19.8986 10.5923L20.2102 10.7172L19.5709 9.15387L19.8809 9.22179L18.9764 8.09668L19.2254 8.01996L17.9759 7.12175L18.3498 7.02297C18.3498 7.02297 17.4262 6.55489 16.3726 7.12175L16.3825 6.92591L16.1056 6.97271L16.122 6.7573L16.3972 6.34036L15.9841 6.18119C15.9841 6.18119 16.3181 5.67951 16.2679 5.68639C16.2679 5.68639 15.8957 5.79321 15.9169 5.74844C15.9169 5.74844 16.1046 5.26493 16.0552 5.27788C16.0552 5.27788 15.6236 5.42468 15.6875 5.35121L15.8534 5.05583L15.8129 4.5Z",
      fill: "#FBCD17"
    })]
  })]
}));
//# sourceMappingURL=PapuaNewGuinea.js.map